class CollectionFilterGroup extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Get all checkbox inputs (NOT wrappers)
        this.checkboxes = this.querySelectorAll('.form-checkbox input[type="checkbox"]');
        this.dropdownToggler = this.querySelector('.collection-filter-group__head');

        this.parent = this.closest('collapsible-section.filter');

        if(!this.checkboxes.length) return;
        if(!this.dropdownToggler) return;

        // Bind events properly
        this.checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => this.updateDropdown());
        });

        document.addEventListener('stock:updated', (e) => {
            this.updateDropdown();
        });

        this.dropdownToggler.addEventListener('click', () => {
            const state = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!state));
        })

        // Initial state
        this.updateDropdown();

        if(this.parent) {
            const title = this.parent.querySelector('.filter__header div');

            if(title) title.innerHTML = title.innerHTML.toLowerCase();
        }

    }

    updateDropdown() {
        const dropdownHeader = this.querySelector('.collection-filter-group__text-filters');
        if (!dropdownHeader) return;

        // Always compute live checked state
        const checked = Array.from(this.querySelectorAll('.form-checkbox__input[checked]'));

        let activeFilters = "";

        // Toggle class
        if (!checked.length) {
            this.classList.add('no-filter');
        } else {
            this.classList.remove('no-filter');
        }

        // Build label string
        if (checked.length === 1) {
            activeFilters = this.getCheckboxLabel(checked[0]);
        } else if(checked.length > 1) {
            checked.forEach((checkbox, index) => {
                if(index < checked.length - 1) activeFilters += this.getCheckboxLabel(checkbox) + ", ";
                else activeFilters += this.getCheckboxLabel(checkbox);
            })
        }

        // Update UI
        dropdownHeader.innerHTML = activeFilters;
    }

    getCheckboxLabel(checkbox) {
        // Find the wrapper, then the label
        const wrapper = checkbox.closest('.form-checkbox');
        if (!wrapper) return '';

        const label = wrapper.querySelector('.form-checkbox__label');
        return label ? label.innerHTML.trim() : '';
    }
}

// Prevent double registration
if (!customElements.get('collection-filter-group')) {
    customElements.define('collection-filter-group', CollectionFilterGroup);
}